import { Component } from '@angular/core';



import { HostListener } from '@angular/core';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent {


@HostListener('window:popstate', ['$event'])
onPopState(event) {
  location.reload()
}
  constructor() {

  }

  ngOnInit() {
  }



}
